export default "__VITE_ASSET__220c7640__$_?inline__"